import _stripTags from "../quill/stripTags.js";
const stripTags = _stripTags;
export default (function removeInvalidEvents(eventGroup, allowMetadata = false) {
  eventGroup.events = eventGroup.events.filter(event => {
    //If allowMetadata is true, then we don't need to check for start, end, or text. We only need to check if the event is longer than 0 seconds.
    if (allowMetadata) {
      return event.end - event.start > 0;
    } else if (event.style.startsWith("Roll-Up")) {
      return true;
    } else {
      const isBlankClear = event.style === "Pop-On" && stripTags(event.text).trim() === "" && event.end - event.start > 0;
      return event.start !== undefined && event.start !== false && event.end !== false && event.end !== undefined && (isBlankClear || stripTags(event.text).trim() !== "") && event.end - event.start > 0;
    }
  });
  return eventGroup;
});